import React from 'react'
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { genfunction } from 'helpers';

const { Merchant1, Merchant2 } = window['runConfig'];

const MultiPayments = () => {

    const events = useSelector(state => state.reducerShopCart.events);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    const donation = useSelector(state => state.reducerShopCart.donation);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    let merchant1Totals = genfunction.CalculateMultiMerchantTotal(events, gaTickets, membershipPackages, giftcards.giftcards, donation, (showTransFee ? transactionfee.transactionFee[0] : null), cashless, donationProducts).merchant1Total;
    let merchant2Totals = genfunction.CalculateMultiMerchantTotal(events, gaTickets, membershipPackages, giftcards.giftcards, donation, (showTransFee ? transactionfee.transactionFee[0] : null), cashless, donationProducts).merchant2Total;

    return (
        <div>
            {merchant1Totals > 0 && merchant2Totals > 0 ?
                <>
                    <Typography color="textSecondary" >The total
                        {' ' + genfunction.ccyFormat(genfunction.subproducttotal(events, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gaTickets, giftcards.giftcards, orderProducts, donationProducts)) + ' '}
                        will be charged in two payments:</Typography>
                    <br />
                    <Typography color="textSecondary">{Merchant1}:  {' ' + genfunction.ccyFormat(merchant1Totals) + ' '}</Typography>
                    <Typography color="textSecondary">{Merchant2}:  {' ' + genfunction.ccyFormat(merchant2Totals) + ' '}</Typography>
                </> :

                merchant1Totals > 0 || merchant2Totals > 0 ?

                    <Typography color="textSecondary" >
                        The total
                        {' ' + genfunction.ccyFormat(genfunction.subproducttotal(events, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gaTickets, giftcards.giftcards, orderProducts, donationProducts)) + ' '}
                        will appear on your statement as  {merchant1Totals > 0 ? Merchant1 : Merchant2} </Typography>
                    : null

            }
        </div>
    )
}

export default MultiPayments
